import type { ExpressCheckoutState } from './types';

export const initialState: ExpressCheckoutState = {
  data: null,
};
